;(function () {
  angular
    .module('contrast.org.dashboard')
    .controller('DashboardAttacksCtrl', DashboardAttacksCtrl)

  function DashboardAttacksCtrl(
    $scope,
    $routeSegment,
    $location,
    ErrorService,
    ChartService,
    UserService,
    LoadFilterService,
    HistoryFactory,
    ScoreFactory,
    csVulnerabilityViolationsService,
    TIME_SERIES_DATES_TODAY,
    ATTACK_BREAKDOWN_TYPES,
    QUICK_FILTERS
  ) {
    'ngInject'

    function init() {
      getThermometerData()
      getTimeseriesData()
    }

    angular.extend($scope, {
      model: {
        vulnViolationsCount: 0
      },
      thermometer: {
        breakdowns: ATTACK_BREAKDOWN_TYPES,
        breakdown: ATTACK_BREAKDOWN_TYPES[0],
        data: []
      },
      timeseries: {
        times: TIME_SERIES_DATES_TODAY,
        time: TIME_SERIES_DATES_TODAY[0],
        data: {}
      },

      orgUuid: $routeSegment.$routeParams.orgUuid
    })

    $scope.$watch(
      function () {
        return csVulnerabilityViolationsService.getCount()
      },
      function () {
        $scope.model.vulnViolationsCount =
          csVulnerabilityViolationsService.getCount()
      }
    )

    angular.extend($scope, {
      onThermometerBreakdownChange: function () {
        getThermometerData()
      },
      onTimeseriesIntervalChange: function () {
        getTimeseriesData()
      },

      onThermometerClick: function (record) {
        if (record.link) {
          if (record.type == 'attack') {
            var location = UserService.buildUrl('/attacks/attacks')
            switch (record.breakdown) {
              case 'Status':
                LoadFilterService.setAttackStatus(record.name.toUpperCase())
                if (record.name == 'probed') {
                  LoadFilterService.setAttackQuickFilter(
                    QUICK_FILTERS.ATTACK_EVENTS.ALL.KEY
                  )
                }
                break

              case 'Type':
                LoadFilterService.setAttackType(record.name.toUpperCase())
                break

              default:
                break
            }
            $location.path(location)
          }
        }
      }
    })

    function getThermometerData() {
      var promise = null,
        breakdown = $scope.thermometer.breakdown

      switch (breakdown) {
        case 'Status':
          promise = ScoreFactory.getAttackBreakdownByStatus()
          break

        case 'Type':
          promise = ScoreFactory.getAttackBreakdownByType()
          break

        default:
          break
      }

      promise.then(
        function (response) {
          $scope.thermometer.data = ChartService.buildAttackThermometerData(
            breakdown,
            response.data
          )
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function getTimeseriesData() {
      return HistoryFactory.getAttacksHistoryByInterval(
        $scope.timeseries.time.value
      ).then(
        function (response) {
          $scope.timeseries.data = ChartService.buildAttackTrendData(
            response,
            $scope.timeseries.time.value
          )
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    init()
  }
})()
